import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './styles/global.css';

// Layout
import Navbar from './components/layout/Navbar';
import AdminLayout from './components/admin/AdminLayout';

// Customer Pages
import HomePage from './pages/customer/HomePage';
import SchoolPage from './pages/customer/SchoolPage';
import KitsListPage from './pages/customer/KitsListPage';
import SchoolKitsLandingPage from './pages/customer/SchoolKitsLandingPage';
import KitPage from './pages/customer/KitPage';
import ProductsPage from './pages/customer/ProductsPage';
import CartPage from './pages/customer/CartPage';
import CheckoutPage from './pages/customer/CheckoutPage';
import OrderPage from './pages/customer/OrderPage';
import MyOrdersPage from './pages/customer/MyOrdersPage';
import TrackOrderPage from './pages/customer/TrackOrderPage';
import FAQsPage from './pages/customer/FAQsPage';
import ContactPage from './pages/customer/ContactPage';
import { LoginPage, RegisterPage } from './pages/customer/AuthPages';

// Admin Pages
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminSchools from './pages/admin/AdminSchools';
import AdminKits from './pages/admin/AdminKits';
import AdminProducts from './pages/admin/AdminProducts';
import AdminCategories from './pages/admin/AdminCategories';
import AdminOrders from './pages/admin/AdminOrders';
import AdminTaxRates from './pages/admin/AdminTaxRates';
import AdminShippingDiscounts from './pages/admin/AdminShippingDiscounts';
import AdminSchoolRequests from './pages/admin/AdminSchoolRequests';
import AdminPriceComparison from './pages/admin/AdminPriceComparison';
import AdminCustomers from './pages/admin/AdminCustomers';

// Customer layout wrapper
const CustomerLayout = ({ children }) => (
  <>
    <Navbar />
    <div style={{ minHeight: 'calc(100vh - 60px)' }}>{children}</div>
    <footer style={{ background: '#1f2937', color: '#9ca3af', fontSize: '0.85rem', marginTop: '2rem', padding: '2rem 1rem' }}>
      <div style={{ display: 'flex', justifyContent: 'center', gap: '2rem', flexWrap: 'wrap', marginBottom: '1rem' }}>
        <a href="/" style={{ color: '#d1d5db', textDecoration: 'none', fontWeight: 600 }}>Find Your School</a>
        <a href="/faqs" style={{ color: '#d1d5db', textDecoration: 'none', fontWeight: 600 }}>FAQs</a>
        <a href="/contact" style={{ color: '#d1d5db', textDecoration: 'none', fontWeight: 600 }}>Contact Us</a>
      </div>
      <div style={{ textAlign: 'center', color: '#6b7280' }}>© 2026 Schoolkit2go</div>
    </footer>
  </>
);

const App = () => (
  <BrowserRouter>
    <Routes>
      {/* Customer Routes */}
      <Route path="/" element={<CustomerLayout><HomePage /></CustomerLayout>} />
      <Route path="/login" element={<CustomerLayout><LoginPage /></CustomerLayout>} />
      <Route path="/register" element={<CustomerLayout><RegisterPage /></CustomerLayout>} />
      <Route path="/schools/:id" element={<CustomerLayout><SchoolPage /></CustomerLayout>} />
      <Route path="/kits" element={<CustomerLayout><SchoolKitsLandingPage /></CustomerLayout>} />
      <Route path="/kits/browse" element={<CustomerLayout><KitsListPage /></CustomerLayout>} />
      <Route path="/kits/:kitId" element={<CustomerLayout><KitPage /></CustomerLayout>} />
      <Route path="/kits/school/:schoolId/grade/:grade" element={<CustomerLayout><KitPage /></CustomerLayout>} />
      <Route path="/products" element={<CustomerLayout><ProductsPage /></CustomerLayout>} />
      <Route path="/cart" element={<CustomerLayout><CartPage /></CustomerLayout>} />
      <Route path="/checkout" element={<CustomerLayout><CheckoutPage /></CustomerLayout>} />
      <Route path="/orders/:id" element={<CustomerLayout><OrderPage /></CustomerLayout>} />
      <Route path="/my-orders" element={<CustomerLayout><MyOrdersPage /></CustomerLayout>} />
      <Route path="/track-order" element={<CustomerLayout><TrackOrderPage /></CustomerLayout>} />
      <Route path="/track-order/:orderNumber" element={<CustomerLayout><TrackOrderPage /></CustomerLayout>} />
      <Route path="/faqs" element={<CustomerLayout><FAQsPage /></CustomerLayout>} />
      <Route path="/contact" element={<CustomerLayout><ContactPage /></CustomerLayout>} />

      {/* Admin Routes */}
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<AdminDashboard />} />
        <Route path="schools" element={<AdminSchools />} />
        <Route path="kits" element={<AdminKits />} />
        <Route path="products" element={<AdminProducts />} />
        <Route path="categories" element={<AdminCategories />} />
        <Route path="orders" element={<AdminOrders />} />
        <Route path="tax-rates" element={<AdminTaxRates />} />
        <Route path="shipping-discounts" element={<AdminShippingDiscounts />} />
        <Route path="school-requests" element={<AdminSchoolRequests />} />
        <Route path="price-comparison" element={<AdminPriceComparison />} />
        <Route path="customers" element={<AdminCustomers />} />
      </Route>

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </BrowserRouter>
);

export default App;
